module.exports = __webpack_public_path__ + "img/sujie.4b7e95e4.jpg";